import { runFingerprintProFlow } from "@/utils/fingerprintPro"

export const useFetchFingerprintPro = () => {
  const websiteInfoStore = useWebsiteInfoStore()

  const fetchFingerprintPro = () => runFingerprintProFlow(websiteInfoStore.state.userID)

  return {
    fetchFingerprintPro
  }
}

export default useFetchFingerprintPro
